.
<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :items="items"
        ><template slot="title">
          {{ $tc("changeSettlementModel.title") }}
        </template></Header
      >
      <v-col class="mt-n5">
        <ChangeTables
          :seeTables="true"
          :headers1="headerEmployed"
          :headers2="headerGroup"
          :title1="modelEmployed"
          :title2="modelGroup"
          :items1="getModelEmployed"
          :items2="getModelGroup"
        />
      </v-col>
      <v-col completeForm>
        <CardDialog style="display: flex; justify-content: center">
          <template slot="title">
            <h4 style="color: #39537a; font-weight: lighter !important">
              {{ $tc("changeGroup.completeForm") }}
            </h4>
          </template>
          <template slot="body">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              class="mx-2"
              :disabled="signed"
            >
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-select
                dense
                v-model="data.model"
                required
                :rules="rules"
                :items="getModels"
                item-value="liqmodelId"
                item-text="name"
                outlined
                :label="$tc('changeSettlementModel.model')"
              />
              <date class="ml-0" />
            </v-form>
            <div class="d-flex justify-space-between mx-2 mt-8 mb-n4">
              <v-btn class="bt-exit" @click="cancel()" :disabled="signed"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn
                class="bt-acept"
                @click.prevent="validate"
                :disabled="signed"
              >
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </template>
        </CardDialog>
      </v-col>
    </v-row>
    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Header from "./common/Header.vue";
import CardDialog from "./common/CardDialog.vue";
import ChangeTables from "./common/ChangeTables.vue";
import Date from "./common/DateRegis.vue";
export default {
  components: { Header, CardDialog, ChangeTables, Date },
  props: {
    items: Object,
    refreshForm: Number,
  },
  data() {
    return {
      headerEmployed: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
      ],
      headerGroup: [
        {
          text: "Nombre",
          value: "liqModel",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
      ],
      modelEmployed: this.$tc("changeSettlementModel.modelEmployees"),
      modelGroup: this.$tc("changeSettlementModel.modelGroup"),
      counter: 0,
      valid: true,
      error: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      alertError: false,
      alertOk: false,
      textAlert: "",
      fromMenuDate: false,
      toMenuDate: false,
      checkTo: this.$store.state.gestionTiempos.checkTo,
      data: {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        model: null,
      },
    };
  },
  watch: {
    refreshForm(newValue, oldValue) {
      if (newValue > oldValue) {
        this.$refs.form.resetValidation();
        this.data = {
          date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
          from: this.$store.state.gestionTiempos.dateFromComponents,
          to: this.$store.state.gestionTiempos.dateToComponents,
          model: null,
        };
      }
    },
  },
  computed: {
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    getModels() {
      return this.$store.state.gestionTiempos.models;
    },
    getModelEmployed() {
      return this.$store.state.changeSettlementModel.modelEmployed.item;
    },
    getModelGroup() {
      return this.$store.state.changeSettlementModel.modelGroup.item;
    },
    model: {
      get() {
        this.data.model = this.$store.state.gestionTiempos.models[0]
          ? this.$store.state.gestionTiempos.models[0].liqmodelId
          : null;
        return this.$store.state.gestionTiempos.models[0]
          ? this.$store.state.gestionTiempos.models[0].liqmodelId
          : null;
      },
      set(val) {
        //
      },
    },
  },
  methods: {
    //validacion del formulario
    validate() {
      if (this.$store.state.gestionTiempos.checkTo) {
        this.$store.commit("gestionTiempos/setDateToComponents", null);
        this.data.to = null;
      }
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.data.from > this.data.to) {
          this.error = true;
          this.alertValidate = this.$tc("autoriz.greater");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.addSettlementModel();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    // se agrega un modelo
    addSettlementModel() {
      let payload = {
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        model: this.data.model,
      };
      this.$store.commit("changeSettlementModel/setNew", payload);
      this.$store
        .dispatch("changeSettlementModel/newSettlementModel")
        .then((r) => {
          this.textAlert = this.$tc("changeSettlementModel.alertOk");
          this.alertOk = true;
          this.reset();
          this.counter++;
          this.$store.dispatch("changeSettlementModel/getModelEmployed");
          this.$store.dispatch("changeSettlementModel/getModelGroup");
          setTimeout(() => {
            this.$emit("close");
          }, 2500);
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = this.$tc("changeSettlementModel.alertError");
          this.reset();
        });
    },
    //se cancela el formulario
    cancel() {
      this.error = false;
      this.reset();
      this.$emit("close");
    },
    //se resetea el formualario
    reset() {
      this.$refs.form.resetValidation();
      this.checkTo = false;
      const today = this.items.date
        .slice(0, 10)
        .split(/\D/)
        .reverse()
        .join("-");
      this.$store.commit("gestionTiempos/setDateFromComponents", today);
      this.$store.commit("gestionTiempos/setDateToComponents", today);
      this.$store.commit("gestionTiempos/setCheckTo", this.checkTo);
      this.data = {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        model: null,
      };
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
